'use client'

import React from 'react'
import Paper from '@mui/material/Paper'
import { styled } from '@mui/material/styles'

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  marginTop: theme.spacing(2),
  // '& p': {
  //   textAlign: 'justify',
  // },
  '& figure': {
    margin: 0,
    padding: 0,
    textAlign: 'center',
    '& img': {
      maxWidth: '100%',
      height: 'auto',
      aspectRatio: '16/9', // Maintain aspect ratio
      display: 'block', // Prevent inline display issues
    },
  },
  // Fix layout shifts for embedded images in content
  '& img': {
    maxWidth: '100%',
    height: 'auto',
    aspectRatio: '16/9', // Default aspect ratio if not specified
    display: 'block',
  },
}))

interface ArticleContentWrapperProps {
  children: React.ReactNode
  elevation?: number
  sx?: any
}

const ArticleContentWrapper: React.FC<ArticleContentWrapperProps> = ({ children, elevation = 3, sx }) => {
  return (
    <StyledPaper elevation={elevation} sx={sx}>
      {children}
    </StyledPaper>
  )
}

export default ArticleContentWrapper
